import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderTitle } from '../../../components/molecues';

class Account extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 8,
            user: this.props.user ? this.props.user : null,
            sendCount: this.props.sendCount ? this.props.sendCount : 0,
            course: this.props.course ? this.props.course : null,
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        let res = {};
        if (prevState.user !== nextProps.user) {
            res.user = prevState.user !== nextProps.user ? nextProps.user : prevState.user;
        }
        if (prevState.course !== nextProps.course) {
            res.course = prevState.course !== nextProps.course ? nextProps.course : prevState.course;
        }
        if (prevState.sendCount !== nextProps.sendCount) {
            res.sendCount = prevState.sendCount !== nextProps.sendCount ? nextProps.sendCount : prevState.sendCount;
        }
        return res;
    }
    onClickPasswordChange = (e) => {
        this.props.history.push('/settingpassword');
    }
    createUserInfo() {
        const course = this.state.course && this.state.user ? this.state.course[this.state.user.course].name : "";
        const sendMax = this.state.course &&  this.state.user ? this.state.course[this.state.user.course].sendMax : 0;
        let count;
        if(sendMax === 0) {
            count = "送信不可";
        } else if(sendMax === -1) {
            count = "無制限";
        } else {
            count = this.state.course && this.state.user ? sendMax - this.state.sendCount : "";
        }
        return (
            <Info>
                ユーザーID : {this.state.user.id}<br/>
                プラン : {course}<br/>
            </Info>
        )
    }
    onClickLogout = (e) => {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'Logout_Saga',
            onSuccess: this.onSuccessLogout,
            onFailure: this.onFailureLogout,
        });
    }
    onSuccessLogout = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.dispatch({
            type: 'Logout',
        });
        this.props.history.push('/login');
    }
    onFailureLogout = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    onClickHome = () => {
        this.props.history.replace('/home');
    }
    render(){
        const propsHeader = {
            current: this.state.current,
            onClickHome: this.onClickHome,
            
        };
        return(
            <Body name="humbergur-menu" Display={this.props.display}>
                <HeaderTitle {...propsHeader}></HeaderTitle>
                {this.createUserInfo()}
                <TextA>
                    プラン・登録情報の変更は<a href="https://docs.google.com/forms/d/e/1FAIpQLScprbyPZyhaphIMsdKjuywXFitSi2Y9xL2cdX-gTjbyaOphzA/viewform" target="_blank" rel="noopener noreferrer">こちら</a>から
                </TextA>
                <TextB><font size="2">（※有料会員様向けのお手続きです）</font><br /><br /></TextB>
                <TextB>
                    パスワードの変更は<Link onClick={this.onClickPasswordChange}>こちら</Link>から
                </TextB>
                <Button onClick={this.onClickLogout}>ログアウトする</Button>
            </Body>
        );
    }
}


const mapStateToProps = store => {
    return {
        user: store.login.user,
        sendCount: store.login.sendCount,
        course: store.setting.course,
    }
};

const connectedAccount = connect(mapStateToProps)(Account);
export { connectedAccount as Account };

const Body = styled.div`
     font-size: 16px;
`;
const TextA = styled.div`
    text-align:center;
    a:link, a:visited, a:hover, a:active {
        color: #0077ff;
    }   
`;
const TextB = styled.div`
    display:flex;
    justify-content: center;
`;
const Link = styled.div`
    color:#0077ff;
`;

const Info = styled.div`
    padding: 10px 10px 30px 10px;
    text-align: left;
`;
const Button = styled.div`
    width: 150px;
    padding: 10px 0;
    margin: 30px auto;
    text-align: center;
    border-radius: 5px;
    background-color:#f2f2f2;
`;